import { organisationsCoreAPI } from './core';
import { organisationsMetricsAPI } from './metrics';
import { organisationsMembersAPI } from './members';
import { organisationsRepositoriesAPI } from './repositories';
import { organisationsSkillsAPI } from './skills';
import { organisationsIntegrationsAPI } from './integrations';
import { organisationsPortfolioAPI } from './portfolio';
import { organisationsActivityAPI } from './activity';

export const organisationsAPI = {
  ...organisationsCoreAPI,
  ...organisationsMetricsAPI,
  ...organisationsMembersAPI,
  ...organisationsRepositoriesAPI,
  ...organisationsSkillsAPI,
  ...organisationsIntegrationsAPI,
  ...organisationsPortfolioAPI,
  ...organisationsActivityAPI,
};
